export enum FilterType {
  MultiTags,
  CheckBox,
  TextInput,
  SelectAutocomplete
}
